import React, { useContext } from 'react';

import { HeaderTitle, Step } from 'app/modules/RestorePassword/types';

import { Modal } from 'app/design-system/components/Modal';
import { tFunction, useTranslation } from 'app/lang';
import { SigningHelpButton } from 'app/modules/Signing/components/SigningHelpButton';
import { allowFreshChat } from 'app/ssr/config';

import { StepContext } from '../../contexts/stepContext';

import dictionary from './ModalHeader.dictionary.json';

import styles from './ModalHeader.module.scss';

const getHeaderTitle = (t: tFunction): HeaderTitle => ({
  INITIAL: t(dictionary.mainHeaderTitle),
  CODE: t(dictionary.mainHeaderTitle),
  PASSWORD: t(dictionary.passwordHeaderTitle),
  DONE: t(dictionary.doneHeaderTitle),
});

export const ModalHeader = (): JSX.Element => {
  const { t } = useTranslation();
  const { activeStep } = useContext(StepContext);

  const headerTitle = getHeaderTitle(t);

  const title = headerTitle[Step[activeStep]];

  return (
    <Modal.Header
    className={styles.headerContent}
    data-test="Modal-restorePassword-header">
      <div className={styles.title}>
        {title}
      </div>
      {allowFreshChat && <SigningHelpButton />}
    </Modal.Header>
  );
};
